import React, { useState } from 'react';
import { useToggle } from 'react-use-v13';
import { Typography, Checkbox, Autocomplete, Accordion, Button, Icon } from '@scale/scaleui';
import {
  NLPConditionPatternGroup,
  NLPLintCondition,
} from '@scale/shared/task_lint/linters/categorization';
import ConditionPatternGroupBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ConditionPatternGroupBuilder';
import SAlert from 'react-s-alert';
import _ from 'lodash';
import { TextCollectionField } from '@scale/shared/types/params/textcollection';

const ConditionBuilder: React.FC<{
  index: number;
  condition: NLPLintCondition;
  updateCondition: (newCondition: NLPLintCondition) => void;
  deleteCondition: () => void;
  fields?: Array<TextCollectionField>;
  taskTemplateParams?: Record<string, any>;
}> = ({ index, condition, updateCondition, deleteCondition, fields }) => {
  const [newFieldId, setNewFieldId] = useState<string>('');
  const [isNegativePatternType, togglePatternType] = useToggle(false);

  const setPatternGroup = (fieldId: string, newPatternGroup: NLPConditionPatternGroup) => {
    updateCondition({
      ...condition,
      [fieldId]: newPatternGroup,
    });
  };
  const removePatternGroup = (fieldId: string) => {
    updateCondition(_.omit(condition, [fieldId]));
  };
  const addPatternGroup = (fieldId: string, negative: boolean = false) => {
    if (!fieldId) {
      SAlert.error('Field ID must not be empty');
      return;
    }
    const newCondition = { ...condition };
    if (negative) {
      newCondition[fieldId] = { not: [''] };
    } else {
      newCondition[fieldId] = [''];
    }
    updateCondition(newCondition);
  };
  return (
    <div className="flex flex-row items-center gap-2">
      <Accordion
        className="flex-1"
        header={
          <div>
            <Typography.Paragraph3>Condition {index + 1}</Typography.Paragraph3>
          </div>
        }
        target={
          <div>
            {Object.keys(condition).map((fieldId, i) => (
              <div key={fieldId}>
                <ConditionPatternGroupBuilder
                  fieldId={fieldId}
                  patternGroup={condition[fieldId]}
                  updatePatternGroup={(newPatternGroup: NLPConditionPatternGroup) =>
                    setPatternGroup(fieldId, newPatternGroup)
                  }
                  deletePatternGroup={() => removePatternGroup(fieldId)}
                  fields={fields}
                />
                {i !== Object.keys(condition).length - 1 && (
                  <div className="mt-2">
                    <Typography.Paragraph1>AND</Typography.Paragraph1>
                  </div>
                )}
              </div>
            ))}
            <div className="flex flex-row gap-4 items-center">
              <Autocomplete
                options={fields?.map(field => field.field_id) || []}
                value={newFieldId}
                setSelectedOption={selectedOption => {
                  setNewFieldId(selectedOption || '');
                }}
              />
              <Checkbox
                checked={isNegativePatternType}
                label="Negate"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  togglePatternType(e.target.checked);
                }}
              />
              <div>
                <Button onClick={() => addPatternGroup(newFieldId, isNegativePatternType)}>
                  Create Pattern Group
                </Button>
              </div>
            </div>
          </div>
        }
      />
      <div>
        <Icon onClick={deleteCondition} icon="trash" variant="danger" />
      </div>
    </div>
  );
};

export default ConditionBuilder;
